/**
 * The liquid-glass material theme is Phibian's default. `html[data-glass]`
 * gates every rule that re-materializes an existing surface (see the material
 * system section of app.css), so this attribute is also the KILL SWITCH: an
 * operator can restore the previous UI wholesale by setting the localStorage
 * key `cwos.admin.glass-proto` to `'0'`, and a test can compare both themes
 * by toggling the attribute.
 *
 * An explicit prior choice is respected so harnesses (`.shots/`) and support
 * sessions can pin either theme before the app module evaluates.
 */
export function installTheme(): void {
  try {
    if (window.localStorage.getItem('cwos.admin.glass-proto') === '0') return;
  } catch {
    /* storage unavailable — default applies */
  }
  document.documentElement.setAttribute('data-glass', 'true');
}
